import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../../App";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";

function useReports() {
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');
    const [isOpen, setIsOpen] = useState(true);
    const openView = (val) => setIsOpen(val);
    const [objData, setobjData] = useState({});
    const [visible, setvisible] = useState(false);
    const [borrowerReportVisible, setborrowerReportVisible] = useState(false);
    const [loanReportVisible, setloanReportVisible] = useState(false);
    const [loanApplicationReportVisible, setloanApplicationReportVisible] = useState(false);
    const [loanApplicationDynamicReportVisible, setloanApplicationDynamicReportVisible] = useState(false);
    const [disbursedReportVisible, setdisbursedReportVisible] = useState(false);
    const [masterReportVisible, setmasterReportVisible] = useState(false);
    const [rfdReportVisible, setRfdReportVisible] = useState(false);
    const [coappReportVisible, setCoappReportVisible] = useState(false);
    const [QueryRaisedVisible, setQueryRaisedVisible] = useState(false);
    const [QueryResolvedVisible, setQueryResolvedVisible] = useState(false);
    const [borrowerReportSectionVisible, setBorrowerReportSectionVisible] = useState(false);
    const [objData1, setObjData1] = useState({ "additional-select": [] });
    const [report_history, setreport_history] = useState([])
    const [user, setuser] = useState();
    const [filename, setfilename] = useState("Report.xlsx");
    const navigate = useNavigate();
    const [rowNumber, setRowNumber] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [response_msg, setresponse_msg] = useState("Loading...");
    const [loading, setLoading] = useState(false);
    const [downloadingId, setDownloadingId] = useState(null);
    const [loginMISReportVisible, setLoginMISReportVisible] = useState(false);
    function formatDate(dateStr) {
        const monthNames = {
            Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
            Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
        };

        // 1. Month-name format: "Wed Sep 16 2026 12:24:32 GMT+0530 (...)"
        const match = dateStr.match(/([A-Za-z]{3})\s+(\d{1,2})\s+(\d{4})/);
        if (match) {
            const [, mon, day, year] = match;
            const month = monthNames[mon];
            if (month) {
                return `${day.padStart(2, '0')}-${month}-${year.slice(-2)}`;
            }
        }

        // 2. ISO 8601: "2026-09-01T09:09" or "2026-09-01T09:09:00Z" etc.
        if (/^\d{4}-\d{2}-\d{2}T/.test(dateStr)) {
            const [datePart] = dateStr.split('T');
            const [y, m, d] = datePart.split('-');
            return `${d}-${m}-${y.slice(-2)}`;
        }

        // 3. Slash format: "01/09/2026"
        if (dateStr.includes('/')) {
            const [d, m, y] = dateStr.split('/');
            return `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
        }

        // 4. Dash format: "2026-09-01"
        const [y, m, d] = dateStr.split('-');
        return `${d}-${m}-${y.slice(-2)}`;
    }
    // useEffect(() => {
    //     const formatted = report_history.map((entry) => ({
    //         ...entry,
    //         start_date: formatDate(entry.start_date),
    //         end_date: formatDate(entry.end_date),
    //     }));
    //     setreport_history(formatted)
    //     // eslint-disable-next-line 
    // }, [user, token, email, navigate, currentPage, rowNumber, totalPages, totalRecords])

    useEffect(() => {
        if (email === "rupesh.bishnoi@credin.in") {
            setvisible(true);
        } else {
            axios
                .post(url + "/user/getsingle", {
                    token: token,
                    email: email,
                    useremail: email
                })
                .then((res) => {
                    console.log("user res->", res);
                    setuser(res?.data[0])
                    if (res.data.logout === true) {
                        toast.error(res.data.message, {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                        setTimeout(() => {
                            navigate("/");
                        }, 3000);
                    }
                    else {
                        console.log("permissions-> ", res?.data[0]?.permission)
                        setborrowerReportVisible(res?.data[0]?.permission?.borrower_report_types);
                        setQueryResolvedVisible(res?.data[0]?.permission?.resolved_query);
                        setQueryRaisedVisible(res?.data[0]?.permission?.raised_query)
                        setloanReportVisible(res?.data[0]?.permission?.loan_report_report_types);
                        setdisbursedReportVisible(res?.data[0]?.permission?.disbursement_report_report_types);
                        setmasterReportVisible(res?.data[0]?.permission?.master_report_report_types);
                        setRfdReportVisible(res?.data[0]?.permission?.rfd_report_report_types);
                        setCoappReportVisible(res?.data[0]?.permission?.coapplicant_report_report_types);
                        setloanApplicationReportVisible(res?.data[0]?.permission?.loan_application_report_types);
                        setloanApplicationDynamicReportVisible(res?.data[0]?.permission?.loan_dynamic_application_report_types);
                        setLoginMISReportVisible(res?.data[0]?.permission?.loginMIS_report_report_types);
                        getReports(currentPage, rowNumber);
                    }
                })
                .catch((err) => {
                    toast.error(err, {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                })
            // getMoreReports()
        };
        //eslint-disable-next-line
    }, [token, email, navigate]);
      const date_validation = (startdate, enddate) => {
        const start = new Date(startdate);
        const end = new Date(enddate);
        const now = new Date(); // current date + time — do NOT truncate

        // 1. Validate date parsing
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            toast.error("Invalid date provided", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
            return false;
        }

        // 2. Reject future dates (either start or end) — compare against current timestamp
        if (start > now || end > now) {
            toast.error("Future dates are not allowed", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
            return false;
        }

        // 3. Reject reversed range
        if (start > end) {
            toast.error("Start date cannot be after end date", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
            return false;
        }

        // 4. Enforce max 1-year range
        const differenceInMilliseconds = end - start;
        const days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
        if (days > 366) {
            toast.error("Please generate a data report for 1 year period ", {
                style: {
                    background: "#fab6bb",
                    color: "red",
                    fontSize: "16px",
                    borderRadius: "1rem",
                    borderColor: "white"
                },
            });
            return false;
        }

        return true;
    }
    const goToNextPage = () => {

        if (currentPage < totalRecords) {
            setCurrentPage(prev => prev + 1);
        }

    };

    const goToPrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    const getReports = (page = currentPage, limit = rowNumber, staff_id = user?.staff_id) => {
        setLoading(true)
        axios
            .post(url + "/loan/lmsReports/getAllreports", {
                token,
                email,
                useremail: email,
                page,
                limit,
                staff_id: user?.staff_id
            })
            .then((res) => {
                if (!res.data.auth) return;
                //  console.log("data-> ",res.data.data)
                if (res?.data?.data.length === 0) {
                    setresponse_msg("No data found !")
                }
                setreport_history(res?.data?.data);
                setTotalPages(res?.data?.pagination?.totalPages);
                setTotalRecords(res?.data?.pagination?.totalRecords);
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
                toast.error("Failed to load reports");
                console.error(err);
            });
    };

    useEffect(() => {
        getReports(currentPage, rowNumber);
        // eslint-disable-next-line
    }, [currentPage, rowNumber, totalPages, totalRecords]);


    function markCompleted(_id) {
        setreport_history(prev =>
            prev?.map(val =>
                val._id === _id
                    ? { ...val, status: "COMPLETED" }
                    : val
            )
        );
    }
    const paginationViewHandler = (e) => {
        setRowNumber(Number(e?.target?.value));
        setCurrentPage(1);
    };

    const refresh = () => {
        axios
            .post(url + "/loan/lmsReports/getAllreports", {
                token,
                email,
                useremail: email,
                page: 1,
                limit: 10,
                staff_id: user?.staff_id
            })
            .then((res) => {
                if (!res.data.auth) return;
                // setreport_history(res.data.data);
                // console.log("refesh data => ", res.data.pagination.totalRecords)
                setTotalPages(res.data.pagination.totalPages);
                setTotalRecords(res.data.pagination.totalRecords);

                if (res.data.logout === true) {
                    toast.error(res.data.message);
                    setTimeout(() => navigate("/"), 3000);
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error("Failed to refresh reports", {
                    style: {
                        background: "#fab6bb",
                        color: "red",
                        fontSize: "16px",
                        borderRadius: "1rem",
                    },
                });
            });
        //    window.location.reload();
    };

    const handleChange = (e) => {
        setobjData({ ...objData, [e.target.name]: e.target.value });
        if (e.target.value.includes("login")) {
            setfilename("LOGIN MIS REPORT.xlsx")
        }
        if (e.target.value.includes("borrower")) {
            setfilename("BORROWER REPORT.xlsx")
        }
        else if (e.target.value.includes("disbursed")) {
            setfilename("DISBURSED REPORT.xlsx")
        }
        else if (e.target.value.includes("rfd")) {
            setfilename("RFD REPORT.xlsx")
        }
        else if (e.target.value.includes("master")) {
            setfilename("MASTER REPORT.xlsx")
        }
        else if (e.target.value.includes("coapplicant")) {
            setfilename("COAPPLICANT REPORT.xlsx")
        }
        else if (e.target.value.includes("QueryRaised")) {
            setfilename("QUERYRAISED REPORT.xlsx")
        }
        else if (e.target.value.includes("QueryResolved")) {
            setfilename("QUERYRESOLVED REPORT.xlsx")
        }
        else if (e.target.value.includes("loan")) {
            setfilename("LOAN REPORT.xlsx")
        }
        else if (e.target.value.includes("application")) {
            setfilename("APPLICATION REPORT.xlsx")
        }
        else if (e.target.value.includes("DynamicApplication")) {
            setfilename("DYNAMIC REPORT.xlsx")
        }
        else if (e.target.value.includes("LoanStatus")) {
            setfilename("LOAN STATUS.xlsx")
        }
        else if (e.target.value.includes("Oversight")) {
            setfilename("OVERSIGHT REVIEW.xlsx")
        }
        else {
            setfilename("REPORT.xlsx")
        }
        //    console.log("REAL NAME-> ", e.target.value)
        if (e.target.name === "report-type" && e.target.value === "borrower") {
            setBorrowerReportSectionVisible(true);
        } else {
            setBorrowerReportSectionVisible(false);
        }
    };
    const handleChangeSection = (event) => {
        const { target: { value } } = event;
        if (value.length <= 3) {
            setObjData1({ ...objData1, "additional-select": value });
        }
    }
    const handleChangeDate = (e) => {
        setobjData({ ...objData, [e.target.name]: e.target.value });
    }
    function parseDate(dateStr) {
        const [datePart, timePart] = dateStr.split(", ");
        const [day, month, year] = datePart.split("/");

        return new Date(`${year}-${month}-${day} ${timePart}`);
    }
    const handleClick = (e) => {
        e.preventDefault();
        setCurrentPage(1);

        // console.log("end point=> ", url + `loan/lmsReports/${objData["report-type"]}`)
        console.log("User -> ", user)
        if (date_validation(objData["from-date"], objData["to-date"]) === true) {
            setreport_history(prevState => [
                {
                    user_id: user?.staff_id,
                    username: email === "rupesh.bishnoi@credin.in" ? "Rupesh Bishnoi" : user?.staff_name,
                    reportName: filename.split('.')[0],
                    start_date: objData["from-date"],
                    end_date: objData["to-date"],
                    download_date: formatDate(new Date().toLocaleDateString()),
                    download_time: formatDate(new Date().toLocaleTimeString()),
                    status: "PROCESSING"
                },
                ...prevState
            ]);

            console.log(objData, 'objData');

            axios
                .post(url + `/loan/lmsReports/${objData["report-type"]}`, {
                    token: token,
                    email: email,
                    startdate: objData["from-date"],
                    enddate: objData["to-date"],
                    borrowerSection: objData1["additional-select"]
                }, {
                    timeout: 2147483647 // Maximum possible timeout (~24.8 days)
                })
                .then((res) => {
                    if (res?.data?.auth === false) {
                        toast.error(res.data.message, {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                        refresh();
                    } else if (res?.data?.message.length === 0) {

                        toast.error("Data Not Found for this Duration", {
                            style: {
                                background: "#fab6bb",
                                color: "red",
                                fontSize: "16px",
                                borderRadius: "1rem",
                                borderColor: "white"
                            },
                        });
                        // setreport_history(prevState => [
                        //     {
                        //         user_id: user?.staff_id,
                        //         username: user?.staff_name,
                        //         reportName: filename.split('.')[0],
                        //         start_date: objData["from-date"],
                        //         end_date: objData["to-date"],
                        //         download_date: formatDate(new Date().toLocaleDateString()),
                        //         download_time: (new Date().toLocaleTimeString()),
                        //         status: "No data found "
                        //     },
                        //     ...prevState
                        // ])
                        refresh();
                        // setTimeout(() => {
                        //     window.location.reload();
                        // }, 3000);
                    } else if (res.data.message.length !== 0) {
                        // console.log("message before-> ", res.data.message)
                        for (let i = 0; i < res?.data?.message?.length; i++) {
                            // console.log("Entry-> ",res?.data?.message[i])
                            let latestEntry = res?.data?.message[i]?.loan_status_trail?.sort((a, b) => {
                                return parseDate(b?.loan_status_change_date) - parseDate(a.loan_status_change_date);
                            })[0];
                            // console.log("latestEntry-> ", latestEntry)

                            // console.log("key-> ",Object.keys(res?.data?.message[i]).map((val)=> val.replace('_',' ')))

                            if (res?.data?.message) {
                                res.data.message[i].Query_Description = latestEntry?.loan_status_desc;
                                res.data.message[i].Query_Raised_By = latestEntry?.loan_status_change_officer;
                                res.data.message[i].Query_Raised_Date = latestEntry?.loan_status_change_date;
                            }
                            delete res.data.message[i].loan_status_trail;
                        }

                        console.log("message after-> ", res.data.message)
                        // var report, wb;
                        // report = XLSX.utils.json_to_sheet(res.data.message);
                        // wb = XLSX.utils.book_new();
                        // XLSX.utils.book_append_sheet(wb, report, "Sample");
                        // XLSX.writeFile(wb, filename);
                        // // getReports()
                        // toast.success(
                        //   ` ${filename.split('.')[0]} Successfully Fetched`,
                        //   {
                        //     style: {
                        //       background: "#E8F7EF",
                        //       color: "green",
                        //       fontSize: "16px",
                        //       borderRadius: "1rem",
                        //       borderColor: "white"
                        //     },
                        //   }
                        // );
                        // markCompleted();
                    }
                    // markCompleted();
                    refresh()
                    setCurrentPage(1);
                })
                .catch((err) => {
                    setreport_history(prevState => prevState.slice(1));
                    setreport_history(prevState => [
                        {
                            user_id: user?.staff_id,
                            username: user?.staff_name,
                            reportName: filename.split('.')[0],
                            start_date: objData["from-date"],
                            end_date: objData["to-date"],
                            download_date: formatDate(new Date().toLocaleDateString()),
                            download_time: (new Date().toLocaleTimeString()),
                            status: "IN QUEUE"
                        },
                        ...prevState
                    ]);
                    console.log(err.message)
                    toast.error(err.message, {
                        style: {
                            background: "#fab6bb",
                            color: "red",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    setCurrentPage(1);
                });
        }

        console.log("history-> ", report_history)

        setRowNumber(rowNumber)
        setCurrentPage(currentPage)
        console.log("after-> ")
        console.log("row number=> ", rowNumber)
        console.log("currentPage number=> ", currentPage)

    };
    const download_report = (file_key, file_id, file_type) => {
        setDownloadingId(file_id);
        axios
            .post(url + "/loan/lmsReports/download", {
                token: token,
                email: email,
                useremail: email,
                file_key: file_key
            })
            .then((res) => {
                console.log("res-> ", res)
                if (res.data.auth === false) {
                    toast.error(res?.data?.message, {
                        style: {
                            background: "#fc054b",
                            color: "#fcfeff",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    setDownloadingId(null)
                    return;
                }
                if (res?.data?.message?.Body?.data) {

                    //console.log("download data=> ", res?.data?.message?.Body?.data);

                    const byteArray = new Uint8Array(res?.data?.message?.Body?.data);

                    const blob = new Blob([byteArray], {
                        type: res?.data?.message?.Body?.ContentType
                    });

                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = file_type + `_${file_id}_.` + filename?.split('.')[1];
                    link.click();
                    setDownloadingId(null)
                }
                else {
                    toast.error(res?.data?.message, {
                        style: {
                            background: "#fc054b",
                            color: "#fcfeff",
                            fontSize: "16px",
                            borderRadius: "1rem",
                            borderColor: "white"
                        },
                    });
                    setDownloadingId(null)
                }

                if (res.data.logout === true) {
                    setDownloadingId(null)
                    toast.error(res.data.message);
                    setTimeout(() => {
                        navigate("/");
                    }, 3000);
                }
            })
            .catch((err) => {
                // toast.error(err.message, {
                //     style: {
                //         background: "#fc054b",
                //         color: "#fcfeff",
                //         fontSize: "16px",
                //         borderRadius: "1rem",
                //         borderColor: "white"
                //     },
                // });
                console.log("Error-> ", err)
                setDownloadingId(null)
            })
    }

    useEffect(() => {

    }, [currentPage, totalPages, totalRecords, report_history, report_history?.length])
    return {
        token, email, isOpen, setIsOpen, openView, objData, setobjData, visible, setvisible,
        borrowerReportVisible, setborrowerReportVisible, loanReportVisible, setloanReportVisible, disbursedReportVisible,
        setdisbursedReportVisible, masterReportVisible, setmasterReportVisible, rfdReportVisible, setRfdReportVisible,
        coappReportVisible, setCoappReportVisible, QueryRaisedVisible, setQueryRaisedVisible, QueryResolvedVisible,
        setQueryResolvedVisible, borrowerReportSectionVisible, setBorrowerReportSectionVisible, objData1, setObjData1,
        report_history, setreport_history, user, setuser, filename, setfilename, navigate, rowNumber, setRowNumber, currentPage,
        setCurrentPage, totalPages, setTotalPages, totalRecords, loanApplicationReportVisible, setloanApplicationReportVisible,
        setTotalRecords, response_msg, setresponse_msg, goToNextPage, goToPrevPage, getReports, markCompleted, paginationViewHandler,
        refresh, handleChange, handleChangeSection, handleChangeDate, parseDate, handleClick, download_report, formatDate,
        loanApplicationDynamicReportVisible, loading, downloadingId, loginMISReportVisible, setLoginMISReportVisible
    };
}
export default useReports;